export const EMAIL_VERIFIED = {
  VERIFICATION: 'Email Verification',
  GET_STARTED: 'Get Started',
};
